<template>
  <div>
    <Filters v-model="filterData" />
    <catalog-table
      ref="table"
      large-content
      :table-data="fetchedData"
      :tableHeaders="headers"
      :tableFilters="filters"
      :page-size="currentPageSize"
      :pagination-info="paginationInfo"
      :loading="loading"
      :loading-content-props="loadingProps"
      @pageUpdated="currentPage = $event"
      @updatedSearchQuery="filterData.searchQuery = $event"
      @updatedPageSize="currentPageSize = $event"
    >
      <div slot="sinisterNumber-cell" slot-scope="{ item }">
        <button class="btn-link" @click="goToSinisterFile(item)">
          {{ item.sinisterNumber }}
        </button>
        <md-tooltip md-direction="top"> Ir a ficha </md-tooltip>
      </div>
    </catalog-table>
  </div>
</template>

<script>
import Filters from "./Filter";
import { CatalogTable } from "@/components/";

import moment from "moment";
import { debounce } from "lodash";

import sinisterService from "@/services/sinister";

export default {
  name: "RejectedQuantificationReportIndex",
  components: {
    Filters,
    CatalogTable,
  },
  data() {
    return {
      filterData: {
        searchQuery: null,
        dateFrom: moment().subtract(15, "days").format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
      },
      currentPage: 1,
      currentPageSize: 10,
      fetchedData: [],
      paginationInfo: null,
      loading: null,
      headers: {
        sinisterNumber: "Siniestro",
        are: "Analista asignado",
        assignmentDate: "Fecha de asignación",
        rejectDate: "Fecha de rechazo",
        rejectionDays: "Días sin avanzar",
      },
      loadingProps: {
        emptyLabel: "No hay siniestros que mostrar.",
        emptyDescription: "Intente más tarde o redefina su consulta.",
      },
      filters: {
        folioJB: (folio) => (folio && folio) || "Sin folio",
      },
    };
  },
  computed: {
    fetchParams() {
      const filtersParams = this.filtersParams;
      const searchQuery = this.filterData.searchQuery;

      return { ...filtersParams, searchQuery };
    },
    filtersParams() {
      const page = this.currentPage;
      const pageSize = this.currentPageSize;
      const from = this.filterData.dateFrom;
      const to = this.filterData.dateTo;

      return {
        page,
        pageSize,
        from,
        to,
      };
    },
  },
  methods: {
    fetchData() {
      this.loading = true;
      return sinisterService
        .fetchRejectedQuantifications(this.fetchParams)
        .then(({ quantificationList, paginationInfo }) => {
          this.fetchedData = quantificationList;
          this.paginationInfo = paginationInfo;
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.loading = false));
    },
    goToSinisterFile(roadSinister) {
      const routeData = this.$router.resolve({
        name: "Ficha de Siniestro Carretero",
        params: {
          id: roadSinister.sinisterId,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
  mounted: {},
  watch: {
    filtersParams: {
      deep: true,
      immdiate: true,
      handler(newVal) {
        let dFrom = moment(newVal.dateFrom);
        let dTo = moment(newVal.dateTo);
        if (dFrom.isSameOrBefore(dTo, "day")) {
          this.debouncedFetch(this.fetchData, newVal);
        } else {
          this.$notify({
            message: "Rango de fechas incorrecto",
            icon: "close",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        }
      },
    },
    "paginationInfo.previous": function (value) {
      this.currentPage = (value || 0) + 1;
    },
    paginationInfo(value) {
      this.$emit("update:paginationInfo", value);
    },
    currentPageSize() {
      this.currentPage = 1;
    },
    "filterData.searchQuery": debounce(function () {
      this.currentPage = 1;
      this.fetchData().then(() => {
        if (this.$refs.sinistersTable) {
          this.$refs.sinistersTable.focusSearch();
        }
      });
    }, 500),
  },
  mounted() {
    this.debouncedFetch = debounce((callback, ...args) => {
      callback(args);
    }, 500);
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Reports/RejectedQuantification/Index.vue